<template>
  <div class="pb50">
    <el-form ref="form" size="small" :model="form" label-width="200px">
      <div class="common-form">积分设置</div>
      <el-form-item label="积分名称 " prop="points_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.points_name" autocomplete="off" class="max-w460"></el-input>
        <div class="lh18 mt10 gray9">
          <p>注：修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称</p>
          <p>例：商家使用自定义的积分名称来做品牌运营。如京东把积分称为"京豆"，淘宝把积分称为"淘金币"</p>
        </div>
      </el-form-item>
      <el-form-item label="积分说明" :rules="[{required: true,message: ' '}]">
        <el-input type="textarea" rows="5" v-model="form.describe" autocomplete="off"></el-input>
      </el-form-item>
    
      <div class="common-form">积分抵扣</div>
      <el-form-item label=" 是否允许下单使用积分抵扣 ">
        <el-radio-group v-model="form.is_shopping_discount" class="max-w460">
          <el-radio :label="1">允许</el-radio>
          <el-radio :label="0">不允许</el-radio>
        </el-radio-group>
        <div class="lh18 mt10 gray9">
          <p>注：如开启则用户下单时可选择使用积分抵扣订单金额</p>
        </div>
      </el-form-item>
      <el-form-item label=" 积分抵扣比例">
        <el-input v-model="form.discount.discount_ratio" class="max-w460">
          <template slot="prepend">1个积分可抵扣</template>
          <template slot="append">元</template>
        </el-input>
        <div class="lh18 mt10 gray9">
          <p>例如：1积分可抵扣0.01元，100积分则可抵扣1元，1000积分则可抵扣10元</p>
        </div>
      </el-form-item>
      <el-form-item label=" 抵扣条件">
        <el-input v-model="form.discount.full_order_price" class="max-w460">
          <template slot="prepend">订单满</template>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-input v-model="form.discount.max_money_ratio" class="max-w460">
          <template slot="prepend">最高可抵扣比例</template>
          <template slot="append">%</template>
        </el-input>
        <div class="lh18 mt10 gray9">
          <p>温馨提示：例如订单金额100元，最高可抵扣10%，此时用户可抵扣10元</p>
        </div>
      </el-form-item>
      <el-form-item label=" ">
        <el-input v-model="form.discount.max_money" class="max-w460">
          <template slot="prepend">最高可抵扣金额</template>
          <template slot="append">元</template>
        </el-input>
        <div class="lh18 mt10 gray9">
          <p>温馨提示：设置固定金额后抵扣比例将失效，0元抵扣比例不失效</p>
        </div>
      </el-form-item>
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PointsApi from '@/api/points.js';

export default {
  data() {
    return {
      form: {
        points_name: '',
        describe: '',
        is_shopping_discount: 1,
        discount: {
          discount_ratio: '0.01',
          full_order_price: '0',
          max_money_ratio: '10',
          max_money: '0',
        },
      },
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      PointsApi.getPointsa({}, true).then(data => {
        console.log('API返回数据:', data);
        
        if (data.data && data.data.values) {
          // 使用深拷贝确保响应式
          const apiData = JSON.parse(JSON.stringify(data.data.values));
          
          // 确保所有字段都有值
          self.form.points_name = apiData.points_name || '';
          self.form.describe = apiData.describe || '';
          self.form.is_shopping_discount = parseInt(apiData.is_shopping_discount) || 1;
          
          // 处理discount对象 - 兼容性写法
          if (apiData.discount) {
            self.form.discount = {
              discount_ratio: this.safeToString(apiData.discount.discount_ratio, '0'),
              full_order_price: this.safeToString(apiData.discount.full_order_price, '0'),
              max_money_ratio: this.safeToString(apiData.discount.max_money_ratio, '0'),
              max_money: this.safeToString(apiData.discount.max_money, '0'),
            };
          }
        }
      }).catch(error => {
        console.error('获取数据失败:', error);
      });
    },

    // 安全转换为字符串的方法
    safeToString(value, defaultValue) {
      if (value === null || value === undefined) {
        return defaultValue;
      }
      return String(value);
    },

    /*保存*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          PointsApi.setPointsa(self.form, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '保存成功',
                  type: 'success'
                });
              } else {
                self.$message.error(data.msg || '保存失败');
              }
            })
            .catch(error => {
              self.loading = false;
              self.$message.error('保存失败');
            });
        }
      });
    },
  }
};
</script>

<style>
.max-w460 {
  width: 460px;
}
.common-form {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.common-button-wrapper {
  margin-top: 30px;
  padding-left: 200px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/points/part/Service.vue